// @flow

import * as React from 'react';

import { localize } from '@ta/common.i18n';
import classnames from '@ta/common.classnames';
import { EscapeHtml } from '@ta/common.text';

import styles from './MemberNameByline.less';

type Props = {|
  name: string,
  isVerified?: boolean,
  url?: string,
  onClick?: (SyntheticEvent<HTMLElement>) => void,
|};

const MemberNameByline = ({ name, isVerified = false, url, onClick }: Props) => {
  const label = url
    ? localize('member_byline_link', {
        '0': styles.prefix,
        '1': classnames({ [styles.verified]: isVerified }, styles.actor),
        '2': url,
        '3': '_blank',
        '4': EscapeHtml(name),
      }) // By <a>{name}</a>
    : localize('mentions_profile_label_span', {
        name: EscapeHtml(name),
        prefixClassName: styles.prefix,
        nameClassName: classnames({ [styles.verified]: isVerified }, styles.actor),
      }); // By <span>{name}</span>
  return (
    <span
      className={styles.label}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: label }}
      onClick={onClick}
    />
  );
};

export default MemberNameByline;
